export const blogHubTagLabel = (title: string): string => `# ${title}`;

export const blogHubUniqueTags = (tags: string[]): string[] => [
  ...new Set(tags.map((tag) => tag.trim()).filter(Boolean)),
];

const SCROLL_EDGE = 1;

export const getHubTagsScrollBehavior = (): ScrollBehavior => {
  if (typeof window === 'undefined') {
    return 'auto';
  }

  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    ? 'auto'
    : 'smooth';
};

export const getHubTagsScrollState = (
  scrollLeft: number,
  clientWidth: number,
  scrollWidth: number,
  contentWidth: number
) => ({
  isOverflowing: contentWidth > clientWidth,
  canScrollLeft: scrollLeft > SCROLL_EDGE,
  canScrollRight: scrollLeft + clientWidth < scrollWidth - SCROLL_EDGE,
});
